import React, { forwardRef, memo } from 'react';
import { Icon } from '../Icon';
import { Link } from '../Link';
import { classnames } from '@src/utils/classnames';
import { getClasses } from '@src/utils/getClass';
import { ITagProps } from './models';
import styled from './Tag.scss';
import { onUnitClickCallback } from '@src/core/Unit';

export const Tag = memo(
  forwardRef<HTMLSpanElement, ITagProps>(
    (
      {
        size = 'md',
        selected,
        clickable,
        view = clickable ? '' : 'basicGreySemiLight',
        className,
        children,
        disabled,
        id,
        href,
        target,
        disableNextJs,
        variant = 'default',
        truncateText = true,
        textColor = 'basicBlack',
        ...props
      },
      ref,
    ) => {
      const isClickable = clickable;

      const classes = classnames(styled.root, className, ...getClasses(styled, { view, size, variant, textColor }), {
        [styled.selected]: isClickable && selected,
        [styled.clickable]: isClickable,
        [styled.disabled]: isClickable && disabled,
        [styled.truncateText]: truncateText,
      });

      return (
        <Link.Wrapper id={id} href={href} target={target} disableNextJs={disableNextJs}>
          <span data-id={id} className={classes} {...props} onClick={onUnitClickCallback(id, props.onClick)} ref={ref}>
            {!isClickable && selected && <Icon name="check" view="basicGreyDark" size="sm" />}
            <span className={styled.text}>{children}</span>
          </span>
        </Link.Wrapper>
      );
    },
  ),
);

Tag.displayName = 'Tag';
